import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLazyQuery } from "@apollo/client";
import { currentViewer, setLocale, setTheme } from "../actions";
import { getViewer } from "../graphql/queries/viewer";

// eslint-disable-next-line import/prefer-default-export
export const useRefreshViewer = () => {
  const [getViewerQuery, { data, error }] = useLazyQuery(getViewer, { errorPolicy: "none" });

  const dispatch = useDispatch();

  useEffect(() => {
    if (data && data.viewer) {
      const { viewer } = data;

      localStorage.setItem("viewer", JSON.stringify(viewer));

      dispatch(currentViewer({ viewer }));
      dispatch(setLocale({ culture: viewer.culture }));
      dispatch(setTheme({ theme: viewer.defaultTheme }));
    }
    else if (error) {
      console?.error("** failed to refresh viewer", { error });
    }
  }, [data, error]);

  return getViewerQuery;
};
